import React, { useEffect, useRef, useState } from 'react';
import { Image, ImageSourcePropType, Modal, StyleSheet, Text, TouchableHighlight, ScrollView, TouchableWithoutFeedback, View } from 'react-native';

import Game from '../../../../shell/Game';
import ImageClass from '../../../../shell/Image';
import { GameObject, TimageINT } from '../../../../store/slices/gameObjectSlice';
import { store } from '../../../../store/store';
import { Checkbox } from '../../../checkbox/index.web';
import { GalleryButton } from '../GalleryButton';
import { GalleryTags } from '../replayScenes/ScenesReplay';
import { galleryScenesList } from './galleryData';
import { WaitForLoadImage } from '../../../../shell/ImageHandler/WaitForLoadImage';

export interface TGallery {
    imageKey: string;
    text: string,
    page: number;
    tags: GalleryTags[],
    seen: boolean;
    conditionScene: string,
    imageCondition?: TimageINT,
    chars: ("vanessa" | "ann" | "jenny" | "amber" | "alex" | "emily" | "merry" | "ramona" | "ivy" | "kim")[];


}

interface GalleryProps {

}


export const Gallery: React.FC<GalleryProps> = ({ }) => {
    const [sceneData, setSceneData] = useState<{ [key: string]: TGallery; }>();
    const [checkedNTR, setCheckedNTR] = useState(true);
    const [imageFullScreen, setImageFullScreen] = useState<TimageINT>();
    const isUnmounted = useRef(false);
    const styles = StyleSheet.create({
        container: {
            marginBottom: 20,
            marginTop: 5,
            flex: 1,
            marginLeft: 15,
            flexWrap: "wrap",
            flexDirection: "row",
            height: "100%",
            alignContent: "center",
        },

    });
    const setSeenScenes = async () => {
        const persistent = await global.electronAPI?.getPersistent();
        if (isUnmounted.current) { return; }
        if (!persistent) {
            // TODO: throw error
            setSceneData(galleryScenesList);
            return;
        }



        Object.keys(galleryScenesList).forEach((scene) => {
            const sceneData = galleryScenesList[scene];
            const imageKey = ImageClass._globalImages.get(sceneData.imageKey)?.key;
            if (!imageKey) { return; }
            if (store.getState().advance.globalSeenImages?.includes(imageKey) ||
                (sceneData.imageCondition ? store.getState().advance.globalSeenImages?.includes(sceneData.imageCondition.key!) : false) ||
                persistent.globalSeenScenarios?.includes(sceneData.conditionScene)) {
                sceneData.seen = true;
            }
        });
        setSceneData(galleryScenesList);


    };

    useEffect(() => {
        setSeenScenes();
        return () => {
            isUnmounted.current = true;
        };
    }, []);


    return (
        <View style={{
            height: "100%",
            display: "flex",
            paddingRight: 20,
            marginBottom: "1S%",
            paddingLeft: 20,

        }}>
            <View style={{
            }}>
                <Checkbox label='NTR?' checked={checkedNTR} onCheck={() => {
                    setCheckedNTR(!checkedNTR);
                }}></Checkbox>
            </View>
            <ScrollView style={{
                paddingBottom: "15%"


            }}>
                {sceneData ?
                    <View style={styles.container}>
                        {Object.keys(sceneData).filter(key => checkedNTR ? true : !sceneData[key].tags.includes("NTR")).map((key, val) => {

                            return <GalleryButton onPress={() => {
                                if (!sceneData[key].seen) {
                                    return;
                                }
                                setImageFullScreen(ImageClass._globalImages.get(sceneData[key].imageKey)?.poster || ImageClass._globalImages.get(sceneData[key].imageKey));
                            }} key={key} scene={sceneData[key]}></GalleryButton>;

                        })}
                    </View> : <></>
                }
            </ScrollView>
            {imageFullScreen ?
                <Modal>
                    <TouchableHighlight activeOpacity={1} style={{ width: "100%", height: "100%", position: "absolute" }} onPress={() => {
                        setImageFullScreen(undefined);
                    }}>
                        <WaitForLoadImage
                            partials={[<Image key={imageFullScreen.key} source={imageFullScreen?.url}
                                style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    opacity: 1,
                                    flex: 1
                                }} resizeMode={'cover'} ></Image >]}
                            disableAnimation source={imageFullScreen.parent?.url || imageFullScreen.url} style={{ width: "100%", height: "100%", position: "absolute" }} />
                    </TouchableHighlight>
                </Modal>
                : <></>}
        </View>
    );
};